import { useState, useEffect } from 'react'

import { AxiosResponse } from 'axios'
import { AxiosError } from 'axios'
import { Row, Select } from 'components'
import { Form, Card, Grid, Button, InputMask } from 'components'
import { useModal, useLoading } from 'hooks'
import { useForm } from 'react-hook-form'
import {
  ArchivesNGTService,
  Entity,
  //IAggregatedParamsArquivos,
  IConfigurationArchivesParam,
  IGetArchivesParam,
  IGetCentroPlanta
} from 'services/NGT/Archives'
import { COLORS, SPACING } from 'utils'

import { TableActions } from './components/TableActions/TableActions'

export default function Archives() {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch
  } = useForm()

  const { showModal } = useModal()
  const { setLoading } = useLoading()
  const [EditId, setEditId] = useState<number | undefined>()
  const [selectValue, setSelectValue] = useState('')
  const [idConfiguration, setIdConfiguration] = useState<number | undefined>()
  const [rows, setRowsState] = useState<Entity[]>()
  const [centros, setCentros] = useState<IGetCentroPlanta[]>([])

  const numeroCaixaExterno = watch('caixaExterno')
  const quantidadeAnosPrescricao = watch('qtdAnosPresc')
  const caixaDepartamental = watch('caixaDepartamental')

  const handleChangeSelect = ({ target: { value } }) => {
    setSelectValue(value)
  }

  // *** Código abaixo foi comentado devido a não implementação das rotas agregadas ***
  // const getInitialData = () => {
  //   ArchivesNGTService()
  //     .aggregatedParametrizacaoArquivos()
  //     .then((response: AxiosResponse<IAggregatedParamsArquivos>) => {
  //       setCentros(response.data.parametrizacao_centroPlanta.entity)
  //       setRowsState(response.data.parametrizacao_arquivos.entity)
  //       setValue(
  //         'caixaExterno',
  //         response.data.parametrizacao_configuracaoParametrizacaoArquivos.entity
  //           ?.numeroCaixaExterno
  //       )
  //       setValue(
  //         'qtdAnosPresc',
  //         response.data.parametrizacao_configuracaoParametrizacaoArquivos.entity
  //           ?.qtdAnosPrescricao
  //       )
  //       setIdConfiguration(
  //         response.data.parametrizacao_configuracaoParametrizacaoArquivos.entity
  //           ?.idConfiguracaoParametrizacaoCaixa
  //       )
  //     })
  //     .catch(() => {
  //       showModal({
  //         hideButtonCancel: true,
  //         message: 'Erro ao obter dados iniciais',
  //         txtButtonConfirm: 'Fechar',
  //         type: 'error'
  //       })
  //     })
  // }

  // useEffect(() => {
  //   getInitialData()
  // }, [])

  useEffect(() => {
    getAllCentroPlanta()
    getConfigurationArchives()
    getAllItensForm()
  }, [])

  const getAllItensForm = async () => {
    setLoading('loading')
    try {
      await ArchivesNGTService()
        .getAll()
        .then(({ data }) => {
          setRowsState(data.entity)
        })
        .catch(() => {
          throw new Error('Erro ao buscar arquivos!')
        })
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao buscar arquivos!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
    setLoading('idle')
  }

  const handleUpdate = (objetoUpdate: Entity) => {
    setValue('caixaDepartamental', objetoUpdate.descricaoCaixa)
    setSelectValue(objetoUpdate.centroPlantaId.toString())
    setEditId(objetoUpdate.idParametrizacaoCaixa)
  }

  const handleUpdateConfiguration = () => {
    setLoading('loading')
    try {
      const newObject = {
        idConfiguracaoParametrizacaoCaixa: idConfiguration,
        numeroCaixaExterno: numeroCaixaExterno,
        quantidadeAnosPrescricao: quantidadeAnosPrescricao
      }

      ArchivesNGTService()
        .updateConfiguration(newObject)
        .then(({ data }) => {
          if (data.sucesso) {
            showModal({
              hideButtonCancel: true,
              message: 'Sucesso ao Atualizar Configuração',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })
            getConfigurationArchives()
          } else {
            throw new Error('error')
          }
        })
    } catch (error) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao atualizar configuração!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
    setLoading('idle')
  }

  const handleClear = () => {
    setValue('caixaExterno', 0)
    setValue('qtdAnosPresc', 0)
    setValue('caixaDepartamental', 0)
    setSelectValue(null)
    setEditId(0)
  }

  const handleDelete = async (id: number) => {
    setLoading('loading')
    ArchivesNGTService()
      .del(id)
      .then(({ data }) => {
        if (data.sucesso) {
          showModal({
            hideButtonCancel: true,
            message: 'Sucesso ao deletar arquivo!',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
          getAllItensForm()
          setLoading('idle')
        } else {
          throw new Error('enviando erro!')
        }
      })
      .catch(() => {
        setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao deletar arquivo!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  const handleSubmitNewItem = async () => {
    if (!isNaN(EditId)) {
      handleUpdateNewItem(EditId)
    } else {
      setLoading('loading')

      const newObj = {
        centroPlantaId: Number(selectValue),
        descricaoCaixa: caixaDepartamental,
        idParametrizacaoCaixa: 0
      }

      ArchivesNGTService()
        .create(newObj)
        .then(({ data }) => {
          if (data.sucesso) {
            showModal({
              hideButtonCancel: true,
              message: 'Sucesso ao Inserir Arquivo!',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })

            setValue('caixaDepartamental', 0)
            setSelectValue(null)
            getAllItensForm()
            setLoading('idle')
          } else {
            throw new Error('erro ao inserir')
          }
        })
        .catch((error) => {
          const axiosError = error as AxiosError
          setLoading('idle')

          showModal({
            hideButtonCancel: true,
            message:
              axiosError.response.data?.title || 'Erro ao inserir arquivo!',
            txtButtonConfirm: 'Fechar',
            type: axiosError.response.status === 400 ? 'alert' : 'error'
          })
        })
        .finally(() => {
          setLoading('idle')
        })
    }
  }

  const handleUpdateNewItem = async (id: number) => {
    try {
      setLoading('loading')

      const newObj = {
        centroPlantaId: Number(selectValue),
        descricaoCaixa: caixaDepartamental,
        idParametrizacaoCaixa: id
      }

      await ArchivesNGTService()
        .update(newObj)
        .then(({ data }) => {
          if (data.sucesso) {
            showModal({
              hideButtonCancel: true,
              message: 'Sucesso ao Atualizar Arquivo!',
              txtButtonConfirm: 'Fechar',
              type: 'success'
            })

            setValue('caixaDepartamental', 0)
            setSelectValue(null)
            setEditId(0)
            getAllItensForm()
            setLoading('idle')
          } else {
            throw new Error('erro ao inserir')
          }
        })
    } catch (error) {
      const axiosError = error as AxiosError

      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          axiosError.response.data?.title || 'Erro ao atualizar arquivo!',
        txtButtonConfirm: 'Fechar',
        type: axiosError.response.status === 400 ? 'alert' : 'error'
      })
    }

    setLoading('idle')
  }

  const getConfigurationArchives = async () => {
    setLoading('loading')
    try {
      await ArchivesNGTService()
        .getConfigurationArchives()
        .then(({ data }) => {
          setValue('caixaExterno', data.entity?.numeroCaixaExterno)
          setValue('qtdAnosPresc', data.entity?.qtdAnosPrescricao)
          setIdConfiguration(data.entity?.idConfiguracaoParametrizacaoCaixa)
          setLoading('idle')
        })
        .catch(() => {
          throw new Error('Erro ao buscar arquivos de configuração!')
        })
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao buscar arquivos de configuração!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const getAllCentroPlanta = async () => {
    setLoading('loading')
    try {
      await ArchivesNGTService()
        .getCentroPlantas()
        .then(({ data }) => {
          if (data.entity && data.sucesso) {
            setCentros(data.entity)
            return
          }

          throw new Error('Erro ao buscar centros planta!')
        })
        .catch(() => {
          throw new Error('Erro ao buscar centros planta!')
        })
    } catch (err: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao buscar centros planta!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
    setLoading('idle')
  }

  return (
    <Form
      onSubmit={handleSubmit(() => undefined)}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Grid
          gridCols="3.5fr 1fr 1fr 1fr 1fr 2fr"
          gridGap={`0 ${SPACING.spacing10}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <Select
            value={selectValue}
            onChange={(e) => handleChangeSelect(e)}
            listOptions={centros}
            label="Centro Planta"
            placeholder={'Selecione'}
            valueMenu="idCentroPlanta"
            labelMenu="txDescricao"
          />
          <InputMask
            control={control}
            errors={errors}
            label="Caixa Departamental"
            formValue="caixaDepartamental"
            placeholder="Nº"
            type="number"
            maxLength={5}
          />
          <Button
            text="+"
            onClick={handleSubmitNewItem}
            type="submit"
            width="1rem"
          />
          <InputMask
            control={control}
            errors={errors}
            label="Caixa Externo"
            formValue="caixaExterno"
            placeholder="Nº"
            type="number"
            maxLength={5}
          />
          <InputMask
            control={control}
            errors={errors}
            formValue="qtdAnosPresc"
            label="Qtd. Anos Prescrição"
            placeholder="Qtd"
            type="number"
            maxLength={5}
          />
        </Grid>

        <Grid
          gridCols="2.3fr 2fr"
          gridGap={`0 ${SPACING.spacing10}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          {rows && (
            <div>
              <TableActions
                listRow={rows}
                handleDelete={handleDelete}
                handleUpdate={handleUpdate}
              />
            </div>
          )}
        </Grid>

        <Row justifyContent="flex-end">
          <Button text="Limpar" variantButton="text" onClick={handleClear} />
          <Button
            text="Salvar"
            type="submit"
            onClick={handleUpdateConfiguration}
            marginLeft={SPACING.spacing20}
          />
        </Row>
      </Card>
    </Form>
  )
}
